import { Description, DialogTitle } from "@headlessui/react";
import { useQueryClient } from "@tanstack/react-query";

import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { USER_KEYS, useChangeSubsAutoPayment } from "@/hooks/api/user.hooks";
import { useLang } from "@/hooks/useLang";
import useModalRouter from "@/hooks/useModalRouter";
import { onError } from "@/utils/onError";
import { onSuccess } from "@/utils/onSuccess";

import Button from "../buttons/Button";

const AutoPaymentModal = () => {
  const { t } = useTranslation();
  const lang = useLang();
  const { mutate: changeAutoPayment, isPending } = useChangeSubsAutoPayment();
  const queryClient = useQueryClient();
  const { closeModal } = useModalRouter();
  const [params] = useSearchParams();
  const subsId = params.get("subs_id");

  useEffect(() => {
    if (!subsId) {
      closeModal();
    }
  }, [subsId]);

  if (!subsId) {
    return;
  }

  const disableAutoPayment = () => {
    changeAutoPayment(
      {
        subscription_id: +subsId,
        auto_payment: false,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: USER_KEYS.userDetail(lang) });
          onSuccess(t("Subscription.canceled"));
          closeModal();
        },
        onError,
      },
    );
  };

  return (
    <div className="max-w-[33rem]">
      <div className={"staff-modal__header text-center"}>
        <DialogTitle as={"h2"} className={"staff-modal__title"}>
          {t("auto-payment.title")}
        </DialogTitle>
        <Description className={"staff-modal__description mb-6 text-on-surface"}>
          {t("auto-payment.description")}
        </Description>
        <div className="flex w-full gap-6">
          <Button className="flex-1" color="black" isLoading={isPending} onClick={disableAutoPayment}>
            {t("auto-payment.disable")}
          </Button>
          <Button className="flex-1" onClick={closeModal}>
            {t("auto-payment.stay")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AutoPaymentModal;
